import React from 'react';
import { Text } from '@amzn/storm-ui-v3';
import { ICellRendererParams } from '@ag-grid-community/core';
import { StyledCellWrapper } from '@urc-ui/components/styles';

export function FormatCell(props: ICellRendererParams) {
  const reportFormat = (props.value as string)?.trim() || '';
  const formatText = reportFormat === 'XLS' ? 'Excel' : reportFormat;
  return (
    <StyledCellWrapper>
      <Text fontSize='small'>{formatText}</Text>
    </StyledCellWrapper>
  );
}
